import { Injector } from "@angular/core";
import { DatasourceService } from "./repositories/datasource/datasource.service";
import { TestGroupsService } from "./repositories/test-groups/test-groups.service";
import { AppsService } from "./repositories/apps/apps.service";
import { UserService } from "./repositories/user/user.service";
import { VendorsService } from "./repositories/vendors/vendors.service";
import { SegmentsService } from "./repositories/segments/segments.service";
import { AttributesService } from "./repositories/attributes/attributes.service";
import { JourneysService } from "./repositories/journeys/journeys.service";
import { AnalyticsService } from "./repositories/analytics/analytics.service";
import { UserManagementService } from "./repositories/user-management/user-management.service";
import { JourneySocketService } from "./repositories/journeys/journey-socket.service";
import { ChargebeeService } from "./repositories/chargebee/chargebee.service";
import { MiscService } from "./repositories/misc/misc.service";
import * as i0 from "@angular/core";
var DatacontextService = /** @class */ (function () {
    function DatacontextService(injector) {
        this.injector = injector;
    }
    Object.defineProperty(DatacontextService.prototype, "datasource", {
        get: function () {
            if (!this._datasourceService) {
                this._datasourceService = this.injector.get(DatasourceService);
            }
            return this._datasourceService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "testGroups", {
        get: function () {
            if (!this._testGroups) {
                this._testGroups = this.injector.get(TestGroupsService);
            }
            return this._testGroups;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "apps", {
        get: function () {
            if (!this._apps) {
                this._apps = this.injector.get(AppsService);
            }
            return this._apps;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "user", {
        get: function () {
            if (!this._user) {
                this._user = this.injector.get(UserService);
            }
            return this._user;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "vendors", {
        get: function () {
            if (!this._vendors) {
                this._vendors = this.injector.get(VendorsService);
            }
            return this._vendors;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "segments", {
        get: function () {
            if (!this._segments) {
                this._segments = this.injector.get(SegmentsService);
            }
            return this._segments;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "attributes", {
        get: function () {
            if (!this._attributes) {
                this._attributes = this.injector.get(AttributesService);
            }
            return this._attributes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "journeys", {
        get: function () {
            if (!this._journeys) {
                this._journeys = this.injector.get(JourneysService);
            }
            return this._journeys;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "analytics", {
        get: function () {
            if (!this._analytics) {
                this._analytics = this.injector.get(AnalyticsService);
            }
            return this._analytics;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "userManagement", {
        get: function () {
            if (!this._userManagement) {
                this._userManagement = this.injector.get(UserManagementService);
            }
            return this._userManagement;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "journeySocket", {
        get: function () {
            if (!this._journeySocket) {
                this._journeySocket = this.injector.get(JourneySocketService);
            }
            return this._journeySocket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "chargebee", {
        get: function () {
            if (!this._ChargebeeService) {
                this._ChargebeeService = this.injector.get(ChargebeeService);
            }
            return this._ChargebeeService;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatacontextService.prototype, "misc", {
        get: function () {
            if (!this._MiscService) {
                this._MiscService = this.injector.get(MiscService);
            }
            return this._MiscService;
        },
        enumerable: true,
        configurable: true
    });
    DatacontextService.ngInjectableDef = i0.defineInjectable({ factory: function DatacontextService_Factory() { return new DatacontextService(i0.inject(i0.INJECTOR)); }, token: DatacontextService, providedIn: "root" });
    return DatacontextService;
}());
export { DatacontextService };
